var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "dateFrom"
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.visits), function(visit) {
    return _c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-sm-3"
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (visit.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(visit.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-right text-info",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name)), _c('br'), _vm._v(" "), (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-lg badge-secondary badge_health_insurance",
      class: '_' + visit.client.health_insurance.code
    }, [_vm._v(_vm._s(visit.client.health_insurance.code === '---' ? visit.client.health_insurance.shortcut : visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-lg pointer badge-warning badge_health_insurance",
      attrs: {
        "role": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")])], 1), _vm._v(" "), (visit.diagnosis.length > 0) ? _c('td', {
      staticClass: "col-sm-6 p-0"
    }, [_c('table', {
      staticClass: "table table-bordered m-0"
    }, _vm._l((visit.diagnosis), function(d) {
      return _c('tr', {
        staticClass: "row m-0"
      }, [_c('td', {
        staticClass: "col-sm-4"
      }, [_vm._v(_vm._s(d.disease.code) + " - " + _vm._s(d.disease.name_cs))]), _vm._v(" "), (d.actions.length > 0) ? _c('td', {
        staticClass: "col-sm-8 p-0"
      }, [_c('table', {
        staticClass: "table table-bordered m-0"
      }, _vm._l((d.actions), function(a) {
        return _c('tr', {
          staticClass: "row m-0"
        }, [_c('td', {
          staticClass: "col-sm-6"
        }, [_vm._v("\n                                                " + _vm._s(a.operation.code) + "  - " + _vm._s(a.operation.name) + "\n                                            ")]), _vm._v(" "), (a.zulp.length > 0) ? _c('td', {
          staticClass: "col-sm-6 p-0"
        }, [_c('table', {
          staticClass: "table table-bordered m-0"
        }, _vm._l((a.zulp), function(z) {
          return _c('tr', {}, [_c('td', {}, [_vm._v("\n                                                            " + _vm._s(z.amount) + "x " + _vm._s(z.medicine.label) + "\n                                                        ")])])
        }))]) : _vm._e()])
      }))]) : _c('td', {
        staticClass: "col-sm-8"
      }, [_vm._m(2, true)])])
    }))]) : _c('td', {
      staticClass: "col-sm-6"
    }, [_vm._m(3, true)]), _vm._v(" "), (visit.medicament.length > 0) ? _c('td', {
      staticClass: "col-sm-3 p-0"
    }, [_c('table', {
      staticClass: "table table-bordered m-0"
    }, _vm._l((visit.medicament), function(m) {
      return _c('tr', {
        staticClass: "m-0"
      }, [_c('td', [_vm._v(_vm._s(m.amount) + "x " + _vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + " " + _vm._s(m.paid_by_sick === true ? ' - hradí nemocný' : ''))])])
    }))]) : _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v("\n                        U návštěvy nebyl předepsán lék\n                    ")])])
  }))])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Seznam návštěv, diagnóz, výkonů a léků")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("RČ/ČP / Klient / pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Výkon(y)")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("ZULP")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Léky")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("\n                                        DIAGNÓZA NEMÁ PŘIŘAZENÉ VÝKONY\n                                        "), _c('i', {
    staticClass: "fa fa-close fa-2x text-danger"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                            U NÁVŠTĚVY NENÍ DIAGNÓZA\n                            "), _c('i', {
    staticClass: "fa fa-close fa-2x text-danger"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7805f1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reporting/components/ReportingList.vue
// module id = 671
// module chunks = 0